{
  "metadata": {
    "id": "synthesis-light",
    "name": "Synthesis",
    "description": "Собственная тема Synth «Synthesis» (light)",
    "author": "Synth",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "synth",
      "own"
    ],
    "source": {
      "file": "tools/lib/make_themes.py",
      "project": "synth",
      "url": null,
      "upstreamFile": null,
      "license": "собственная (Synth)",
      "authoring": "tools/lib/make_themes.py"
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 26.1,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.444,
      "paletteMaxS": 0.518,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.0,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 22.7,
      "syntaxVsTextMinDeltaE": 26.7,
      "chartsMinDeltaE": 29.4,
      "textSeparationDeltaE": 21.1,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "comment",
          "b": "operator",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#CA6008",
      "hover": "#b65607",
      "active": "#a64f07",
      "foreground": "#000000",
      "muted": "#ca600880",
      "emphasis": "#CA6008"
    },
    "surface": {
      "background": "#FAF8F3",
      "foreground": "#1C1917",
      "muted": "#cccac5",
      "mutedForeground": "#474743",
      "elevated": "#b6b4b0",
      "elevatedForeground": "#1C1917",
      "raised": "#9c9995",
      "raisedForeground": "#1C1917",
      "overlay": "#faf8f333",
      "subtle": "#e3e1dc"
    },
    "interactive": {
      "border": "#94928e",
      "borderHover": "#bcbab5",
      "borderFocus": "#CA6008",
      "selection": "#1c191724",
      "selectionForeground": "#1C1917",
      "focus": "#ca600859",
      "focusRing": "#ca600847",
      "cursor": "#100f0f",
      "hover": "#1c191717",
      "active": "#1c191724"
    },
    "status": {
      "error": "#AF3029",
      "errorForeground": "#ffffff",
      "errorBackground": "#af30291a",
      "errorBorder": "#af302959",
      "warning": "#8f6c01",
      "warningForeground": "#ffffff",
      "warningBackground": "#8f6c011a",
      "warningBorder": "#8f6c0159",
      "success": "#627b0b",
      "successForeground": "#ffffff",
      "successBackground": "#627b0b1a",
      "successBorder": "#627b0b59",
      "info": "#237f77",
      "infoForeground": "#ffffff",
      "infoBackground": "#237f771a",
      "infoBorder": "#237f7759"
    },
    "pr": {
      "open": "#627b0b",
      "draft": "#555450",
      "blocked": "#8f6c01",
      "merged": "#BC5215",
      "closed": "#AF3029"
    },
    "syntax": {
      "base": {
        "background": "#cccac5",
        "foreground": "#1C1917",
        "comment": "#555450",
        "keyword": "#485a08",
        "string": "#1a5f59",
        "number": "#5E409D",
        "function": "#8e3e10",
        "variable": "#1d5495",
        "type": "#6b5101",
        "operator": "#555450"
      },
      "tokens": {
        "commentDoc": "#555450",
        "stringEscape": "#555450",
        "keywordImport": "#485a08",
        "storageModifier": "#485a08",
        "functionCall": "#8e3e10",
        "method": "#8e3e10",
        "variableProperty": "#8e3e10",
        "variableOther": "#1d5495",
        "variableGlobal": "#5E409D",
        "variableLocal": "#555450",
        "parameter": "#1d5495",
        "constant": "#5E409D",
        "class": "#6b5101",
        "className": "#6b5101",
        "interface": "#6b5101",
        "struct": "#6b5101",
        "enum": "#6b5101",
        "typeParameter": "#6b5101",
        "namespace": "#6b5101",
        "module": "#485a08",
        "tag": "#485a08",
        "jsxTag": "#485a08",
        "tagAttribute": "#8e3e10",
        "tagAttributeValue": "#1a5f59",
        "boolean": "#5E409D",
        "decorator": "#485a08",
        "label": "#8e3e10",
        "regexp": "#1a5f59"
      }
    },
    "charts": {
      "series": [
        "#CA6008",
        "#237f77",
        "#627b0b",
        "#8f6c01",
        "#AF3029"
      ]
    },
    "chat": {
      "background": "#FAF8F3",
      "userMessage": "#1C1917",
      "userMessageBackground": "#b6b4b0",
      "assistantMessage": "#1C1917",
      "assistantMessageBackground": "#cccac5",
      "timestamp": "#555450",
      "divider": "#94928e",
      "typing": "#555450"
    },
    "loading": {
      "spinner": "#CA6008",
      "spinnerTrack": "#cccac5",
      "skeleton": "#cccac5",
      "shimmer": "#c1bfbb"
    },
    "tools": {
      "background": "#cccac5",
      "border": "#94928e",
      "headerHover": "#c3c1bc",
      "icon": "#b15407",
      "title": "#1C1917",
      "description": "#555450",
      "edit": {
        "added": "#627b0b",
        "addedBackground": "#627b0b1a",
        "removed": "#AF3029",
        "removedBackground": "#af30291a",
        "modified": "#237f77",
        "modifiedBackground": "#237f771a",
        "lineNumber": "#555450"
      }
    },
    "markdown": {
      "heading1": "#1C1917",
      "heading2": "#1C1917",
      "heading3": "#1C1917",
      "heading4": "#1C1917",
      "link": "#b65707",
      "linkHover": "#b65607",
      "inlineCode": "#1a5f59",
      "inlineCodeBackground": "#cccac5",
      "blockquote": "#555450",
      "blockquoteBorder": "#94928e",
      "listMarker": "#c55e08",
      "bold": "#1C1917",
      "italic": "#1c1917e6",
      "strikethrough": "#555450",
      "hr": "#94928e"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#b4413f",
        "foreground": "#ffffff",
        "contrast": 5.57
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#935a36",
        "foreground": "#ffffff",
        "contrast": 5.59
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#cca166",
        "foreground": "#000000",
        "contrast": 8.86
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#829043",
        "foreground": "#000000",
        "contrast": 6.02
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#a4d06b",
        "foreground": "#000000",
        "contrast": 11.81
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#3f963c",
        "foreground": "#000000",
        "contrast": 5.64
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#6cce97",
        "foreground": "#000000",
        "contrast": 10.91
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#438e73",
        "foreground": "#000000",
        "contrast": 5.36
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#6bc3cd",
        "foreground": "#000000",
        "contrast": 10.31
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#3d738b",
        "foreground": "#ffffff",
        "contrast": 5.22
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#4466a9",
        "foreground": "#ffffff",
        "contrast": 5.65
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#3b3cae",
        "foreground": "#ffffff",
        "contrast": 8.59
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#6e3988",
        "foreground": "#ffffff",
        "contrast": 8.07
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#b545b3",
        "foreground": "#ffffff",
        "contrast": 4.7
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#c168a5",
        "foreground": "#000000",
        "contrast": 5.79
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#8a3a55",
        "foreground": "#ffffff",
        "contrast": 7.45
      }
    ]
  }
}
